import getBenefitRequests from "v2/infrastructure/BenefitRequests/repositories/getBenefitRequests";

const findBenefitRequests = ({
  companyId,
  states,
  categories,
}: {
  companyId: string;
  states: string[];
  categories: string[];
}) => {
  return getBenefitRequests({ companyId, states, categories });
};

export default findBenefitRequests;
